import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import './BaseSpacer.scss';
var BaseSpacer = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get isStandardSize() {
            return !p.size || ['xs', 'sm', 'md', 'ml', 'lg', 'xl'].includes(p.size || '');
        },
        get inline() {
            var _a;
            return (_a = p.inline) !== null && _a !== void 0 ? _a : false;
        },
        get style() {
            return {
                width: s.isStandardSize ? undefined : p.size,
                height: s.isStandardSize ? undefined : p.size
            };
        }
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName('BaseSpacer', s.isStandardSize && (p.size || 'md'), s.inline && 'inline'), style: s.style })); } });
};
export default BaseSpacer;
